////////////////////////////////////////////////////////////////////
// This file contains configs that add analytics integrations     //
////////////////////////////////////////////////////////////////////

// Optional
// Note that Google Analytics might need advanced opt-out option / cookie consent
// depending on jurisdiction (e.g. EU countries), since it relies on cookies.

// Uncomment for Google Analytics usage
// export const googleAnalyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

// Set to "false" when running locally, set to "true" before deploying
export const googleAnalyticsEnabled = false;

// Google Tag Manager container id. Single source of truth for the GTM loader.
// The customer's GA4 measurement is configured inside this container, so GA4
// should NOT also be loaded via REACT_APP_GOOGLE_ANALYTICS_ID (that would double-count).
// Override via env to point a non-production environment at a separate container.
export const googleTagManagerId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || 'GTM-N8WZTRT7';

// Optional
// If you add this Plausible integration, you should first create an account in plausible.io
// This adds data-domains for Plausible script through environment variable: REACT_APP_PLAUSIBLE_DOMAINS
// https://plausible.io/docs/plausible-script#can-i-send-stats-to-multiple-dashboards-at-the-same-time
// You can add multiple domains separated by comma
// E.g. REACT_APP_PLAUSIBLE_DOMAINS=example1.com,example2.com
export const plausibleDomains = process.env.REACT_APP_PLAUSIBLE_DOMAINS;
